import type { Type } from "@angular/core";

/**
 * Description of the cell renderer for the Component Factory.
 * The component is instantiated via NgComponentOutlet, which applies `value`/`column` as inputs
 * whether the target declares them via `@Input()` or signal `input()` - no shared interface needed.
 */
export class CellRendererItem {
  public value: any;
  constructor(public component: Type<unknown>) {}
}
